import { action, payload } from 'ts-action'
import { IError, IPayload } from '@network/models/global.model'
import { ITimesheet } from '@network/models/timesheet.model'

export const GetTimesheets = action(
  'GetTimesheets',
  payload<IPayload<ITimesheet[]>>(),
)

export const TimesheetsFetching = action(
  'TimesheetsFetching',
  payload<boolean>(),
)

export const GetTimesheetsErrors = action(
  'GetTimesheetsErrors',
  payload<IError>(),
)
